<div class="w-full flex flex-row gap-1 items-stretch">
    <p-button class="flex-1" styleClass="w-full text-nowrap" label="New" [severity]="value() === 0 ? 'secondary' : 'info'"
        (click)="select(0)" />
    <p-button class="flex-1" styleClass="w-full text-nowrap" label="In Progress" [severity]="value() === 1 ? 'contrast' : 'info'"
        (click)="select(1)" />
    <p-button class="flex-1" styleClass="w-full text-nowrap" label="Completed" [severity]="value() === 2 ? 'success' : 'info'"
        (click)="select(2)" />
</div>